import ManagerPicture from './ManagerPicture.container';

export default ManagerPicture;
